import { Text, VStack, Heading } from '@primerai/thread';
import AppSwitcher from './AppSwitcher';
import { withBranding, AUTHENTICATED } from '~/components/branding';
import config from '~/config';
import { HEADING_SIZE } from '~/constants';

export const WelcomePage = () => (
  <VStack>
    <Text>
      You are logged in but we don't know which of our products you wanted.
    </Text>
    <Text>Please contact your account manager for the appropriate link.</Text>
  </VStack>
);

const ProductsPage = () => (
  <VStack>
    <Heading size={HEADING_SIZE.XLARGE}>Welcome to Primer</Heading>
    {config.SHOW_APP_SWITCHER === 'true' ? <AppSwitcher /> : <WelcomePage />}
  </VStack>
);

export default withBranding(AUTHENTICATED)(ProductsPage);
